import { apiClient } from './client';
import type { NodePublic } from './workspace';

/**
 * 대화 첨부를 내 워크스페이스로 담기 (chat-attachment-save — 2026-08-26).
 *
 * 워크스페이스의 복사 API 를 그냥 쓰지 못하는 이유: 그쪽 권한 판정은 워크스페이스 기준이라
 * **남이 올린 채팅 첨부는 '없는 파일'** 이 된다. 방 멤버는 내려받을 수 있는데 담을 수는 없는
 * 비대칭이 생기므로, 권한을 채팅 기준으로 보는 창구를 따로 둔다(복사 자체는 서버가 같은
 * 함수로 처리한다 — 쿼터·되돌리기가 두 벌로 갈라지지 않는다).
 *
 * parentId 를 생략하면 내 워크스페이스 맨 위에 담긴다.
 */
export async function saveChatAttachmentToWorkspace(
  roomId: string,
  fileId: string,
  input: { parentId?: string | null; name?: string } = {},
): Promise<NodePublic> {
  const { data } = await apiClient.post<{ file: NodePublic }>(
    `/chat/rooms/${roomId}/attachments/${fileId}/save-to-workspace`,
    input,
  );
  return data.file;
}
